import React, { useEffect, useState } from "react";
import axios from "axios";
import "./PlanningTable.css";
import { getToken, base_url } from "../../config/config";

const labelToColorMap = {
  "Materialeingang / Materialausgang mit Kontrolle und Weitergabe an die Produktion incl. Auftragsnummer":
    "#005B96",
  "Baugruppe montieren": "orange",
  "Maschine einrichten": "teal",
  "CNC Fräsen": "#1FD655",
  "Konventionell Fräsen": "#649200",
  "CNC Drehen": "#A2AFB0",
  "Konventionell Drehen": "grey",
  Schweißen: "#95CBE2",
  Sägen: "#844204",
  "Konservieren / Lackieren": "#680000",
  "Verpacken / Versenden": "#E9D700",
  "Transport innerhalb der Firma": "#1E64AF",
  Qualitätskontrolle: "green",
  Sonstiges: "#557882",
  "Angaben Formulare zu re übergeben": "pink",
  Stoßen: "#60CDB8",
  "Normalisieren / Härten": "#373737",
  Löten: "#373737",
  Unterbrechung: "#FFC107",
};

const PlanningTable = () => {
  const [planningData, setPlanningData] = useState([]);
  const [viewByEmployee, setViewByEmployee] = useState(false);

  useEffect(() => {
    const fetchPlanningData = async () => {
      try {
        const response = await axios.get(
          `${base_url}/v1/GetAllProjectPlanning`,
        );
        setPlanningData(response.data);
      } catch (error) {
        console.error("Error fetching planning data", error);
      }
    };
    fetchPlanningData();
  }, []);

  const getDaysOfWeek = () => {
    const startOfWeek = new Date("2024-10-07"); // Assuming Monday as start
    const days = [];
    const dayNames = [
      "Montag",
      "Dienstag",
      "Mittwoch",
      "Donnerstag",
      "Freitag",
      "Samstag",
      "Sonntag",
    ];
    for (let i = 0; i < 5; i++) {
      // Only include Monday to Friday
      const nextDay = new Date(startOfWeek);
      nextDay.setDate(startOfWeek.getDate() + i);
      days.push({ date: nextDay, name: dayNames[i] });
    }
    return days;
  };

  const getWeekNumber = (date) => {
    const startOfYear = new Date(date.getFullYear(), 0, 1);
    const pastDaysOfYear = (date - startOfYear) / 86400000;
    return Math.ceil((pastDaysOfYear + startOfYear.getDay() + 1) / 7);
  };

  const daysOfWeek = getDaysOfWeek();
  const weekNumber = getWeekNumber(new Date("2024-10-07"));

  const machineNames = [
    ...new Set(
      planningData.flatMap((item) => item.data.map((task) => task.machinename)),
    ),
  ];
  const employeeNames = [
    ...new Set(
      planningData.flatMap((item) => item.data.flatMap((task) => task.names)),
    ),
  ];

  const handlePrint = () => {
    const printWindow = window.open("", "", "width=1000,height=800");
    printWindow.document.write(
      "<html><head><title>Print Planning Table</title>",
    );
    printWindow.document.write(
      "<style>@page { size: A3 landscape; margin: 10mm; } body { margin: 0; } .planning-table { zoom: 0.7; width: 100%; } .planning-table td { background-color: inherit !important; } .planning-table table { width: 100%; border-collapse: collapse; } .planning-table th, .planning-table td { border: 1px solid #000; padding: 8px; text-align: left; } .planning-table th { background-color: #f0f0f0; } .planning-table td div { margin: 5px 0; }button { display: none; }</style>",
    );
    printWindow.document.write("</head><body>");

    printWindow.document
      .querySelectorAll("td[data-task-id]")
      .forEach((element) => {
        const taskId = element.getAttribute("data-task-id");
        if (taskId) {
          const task = planningData
            .flatMap((item) => item.data)
            .find((task) => task.id == taskId);
          if (task) {
            const color = labelToColorMap[task.label];
            element.style.backgroundColor = color;
          }
        }
      });
    printWindow.document.write(
      document.querySelector(".planning-table").outerHTML,
    );
    printWindow.document.write("</body></html>");
    printWindow.document.close();
    printWindow.print();
  };

  return (
    <div className='planning-table'>
      <h2>Woche {weekNumber}</h2>
      <button onClick={() => setViewByEmployee(!viewByEmployee)}>
        Toggle View ({viewByEmployee ? "View by Machine" : "View by Employee"})
      </button>
      <button onClick={handlePrint}>Print</button>
      <table>
        <thead>
          <tr>
            <th>{viewByEmployee ? "Employee/Day" : "Machine/Day"}</th>
            {daysOfWeek.map((day, index) => (
              <th key={index}>{day.name}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {viewByEmployee
            ? employeeNames.map((employee, index) => (
                <tr key={index}>
                  <td>{employee}</td>
                  {daysOfWeek.map((day, dayIndex) => {
                    const dayString = day.date.toISOString().split("T")[0];
                    const taskForDay = planningData
                      .flatMap((item) => item.data)
                      .find(
                        (task) =>
                          task.names.includes(employee) &&
                          task.date.startsWith(dayString),
                      );
                    const taskLabel = taskForDay ? taskForDay.label : null;
                    const backgroundColor = taskLabel
                      ? labelToColorMap[taskLabel]
                      : "transparent";
                    return (
                      <td
                        key={dayIndex}
                        style={{ backgroundColor }}
                        data-task-id={taskForDay ? taskForDay.id : ""}>
                        {taskForDay ? (
                          <div>
                            <p>
                              ANR: <b>{taskForDay.anr}</b>
                            </p>
                            <p>
                              Auftragsbezeichnung:{" "}
                              {taskForDay.auftragsbezeichnung || "kein"}
                            </p>
                            <p>Machine: {taskForDay.machinename}</p>
                          </div>
                        ) : (
                          "No Task"
                        )}
                      </td>
                    );
                  })}
                </tr>
              ))
            : machineNames.map((machine, index) => (
                <tr key={index}>
                  <td>{machine}</td>
                  {daysOfWeek.map((day, dayIndex) => {
                    const dayString = day.date.toISOString().split("T")[0];
                    const taskForDay = planningData
                      .flatMap((item) => item.data)
                      .find(
                        (task) =>
                          task.machinename === machine &&
                          task.date.startsWith(dayString),
                      );
                    const taskLabel = taskForDay ? taskForDay.label : null;
                    const backgroundColor = taskLabel
                      ? labelToColorMap[taskLabel]
                      : "transparent";
                    return (
                      <td key={dayIndex} style={{ backgroundColor }}>
                        {taskForDay ? (
                          <div>
                            <p>
                              ANR: <b>{taskForDay.anr}</b>
                            </p>
                            <p>
                              Auftragsbezeichnung:{" "}
                              {taskForDay.auftragsbezeichnung || "kein"}
                            </p>
                            <p>Name: {taskForDay.names.join(", ")}</p>
                          </div>
                        ) : (
                          "No Task"
                        )}
                      </td>
                    );
                  })}
                </tr>
              ))}
        </tbody>
      </table>
    </div>
  );
};

export default PlanningTable;

// CSS (PlanningTable.css)
// Adjust the table styling accordingly
// .planning-table table {
//   width: 100%;
//   border-collapse: collapse;
// }
// .planning-table th, .planning-table td {
//   border: 1px solid #000;
//   padding: 8px;
//   text-align: left;
// }
// .planning-table th {
//   background-color: #f0f0f0;
// }
// .planning-table td div {
//   margin: 5px 0;
// }
